module.exports = __webpack_public_path__ + "static/media/maf-33.f82c3114.png";